import { formatMoney } from '@shopify/theme-currency';

/*
// progress_value needs to be between 0 and 1
const progressMeter = (progress_value) => {
  const svgPath = document.getElementById('RCProgressMeter');

  if (!svgPath) {
    return;
  }

  console.log('progress_value', progress_value);

  const path = new ProgressBar.Path(svgPath, {
    easing: 'easeInOut',
    duration: 500,
  });

  path.animate(progress_value);
};
*/

/**
 * Remove the progress widget if the user is platinum
 * Remove the message if more than $50 away from next tier
 * 
 * @param {string} tier_name 
 */
const progressWidget = (tier_name, count_calls = 0) => {
  console.log('progressWidget', tier_name, count_calls);
  if (count_calls > 5) {
    return;
  }
  
  // Remove progress widget if the user is platinum
  if (tier_name === 'platinum' || tier_name === 'platinium') {
    const progress_widget = document.querySelector('.loyalty-status__progress-widget');
    if (progress_widget) {
      progress_widget.remove();
    }

    const progress_widget_cart = document.querySelector('.cart-loyalty__loyalty-progress-widget');
    if (progress_widget_cart) {
      progress_widget_cart.parentElement.remove();
    }

    const progress_widget_cart_drawer = document.querySelector('.slider-cart__loyalty-progress-widget');
    if (progress_widget_cart_drawer) {
      progress_widget_cart_drawer.remove();
    }

    return;
  }

  // Show the message if more less than $50 away from next tier
  // We can have 2 widgets on the page (social club page and cart drawer)
  const widgets_message = document.querySelectorAll('.lion-tier-progress__context--multi');
  console.log('widgets_message', widgets_message.length);

  if (widgets_message.length === 0) {
    window.setTimeout(() => {
      progressWidget(tier_name, count_calls++);
    }
    , 1000);
    return;
  }

  if (widgets_message.length > 0) {
    const progress_value = widgets_message[0].querySelector('strong')?.innerText ?? '';
    const progress_value_number = parseFloat(progress_value.replace(/[^0-9.-]+/g, ''));
    const progress_value_money = formatMoney(progress_value_number * 100, theme.moneyFormat);
    const new_message = `You are only ${(progress_value_money)} away from the next tier!`;
    if (progress_value_number < 50) {
      widgets_message.forEach((item) => {
        item.querySelector('span').innerHTML = new_message;
        item.classList.add('active');
      });
    }
  }
};

export default async () => {
  // Make sure the page we're in needs to load Loyalty data

  if (typeof window.theme.customer === 'undefined' || typeof window.theme.customer.email === 'undefined' || typeof window.theme.customer.app_signature === 'undefined' || window.Shopify.shop.includes('staging')) {
    return;
  }

  const loyalty_customer = window.theme.customer;
  // const app_proxy_path = '/apps/loyalty/'; // On Heroku
  const app_proxy_path = '/apps/astr-loyalty/'; // On AWS

  const loyalty_data = await fetch(`${app_proxy_path}loyalty-customer${window.theme.customer.app_signature}`);

  if (!loyalty_data.ok) {
    console.error('Failed to fetch loyalty data:', loyalty_data.status, loyalty_data.statusText);
    return;
  }

  const loyalty_data_json = await loyalty_data.json();
  if (!loyalty_data_json) {
    return;
  }
  loyalty_customer.loyalty = loyalty_data_json;

  console.log('[ASTR] loyalty_customer', loyalty_customer);

  const available_dollars = Math.floor(loyalty_customer.loyalty.points_approved / loyalty_customer.points_per_dollar_spent);
  // loyalty_customer.loyalty.points_approved = 200;

  const tier_name = loyalty_customer?.loyalty?.loyalty_tier_membership?.loyalty_tier?.name ?? '';

  $('[data-loyalty-tier]').text(tier_name);

  if ($('.loyalty-replace').length) {
    $('.loyalty-replace').html($('.loyalty-replace').html().replaceAll('{{ data-loyalty-tier }}', tier_name));
  }

  $('[data-loyalty-tier-icon]').addClass(tier_name.toLowerCase());
  $('[data-loyalty-clutch]').html(`<span>$<span class="loyalty-counter">${String(available_dollars)}</span></span><span>ASTR dollars</span>`);
  $('[data-loyalty-clutch-dollar-only]').html(`$<span class="loyalty-counter">${String(available_dollars)}</span>`);
  $('[data-loyalty-points-pending]').html(`<span>${loyalty_customer.loyalty.points_pending}</span><span>points</span>`);
  $('[data-loyalty-points]').html(`<span class="loyalty-counter">${loyalty_customer.loyalty.points_approved}</span><span>points</span>`);
  $('[data-loyalty-dollars]').html(`$<span class="loyalty-counter">${loyalty_customer.loyalty.points_approved / loyalty_customer.points_per_dollar_earned}</span>`);
// $('[data-loyalty-astr-dollars]').html(`$${loyalty_customer.loyalty.points_approved / loyalty_customer.points_per_dollar_spent}`);
  $('[data-loyalty-dollars-spent]').html(`$${loyalty_customer.loyalty.points_spent / loyalty_customer.points_per_dollar_spent}`);

  const formatted_loyalty_amount = (window.Shopify.country === 'US') ? formatMoney((loyalty_customer.loyalty.points_approved / loyalty_customer.points_per_dollar_spent) * 100, theme.moneyFormat) : formatMoney((loyalty_customer.loyalty.points_approved / loyalty_customer.points_per_dollar_spent) * window.Shopify.currency.rate * 100, theme.moneyFormat);

  $('[data-loyalty-astr-dollars]').html(`${formatted_loyalty_amount}`);

  /*
  if (tier_name === 'silver') {
    $('[data-loyalty-next-tier]').text('Gold');
  }
  if (tier_name === 'gold') {
    $('[data-loyalty-next-tier]').text('Platinum');
  }
  if (tier_name === 'platinum' || tier_name === 'platinium') {
    $('[data-loyalty-next-tier]').parent().remove();
  }
  */

  /*
  // Progress bar (to next tier)
  const lower_bound = Number(loyalty_customer.loyalty.loyalty_tier_membership.loyalty_tier.lower_bound);
  const upper_bound = Number(loyalty_customer.loyalty.loyalty_tier_membership.loyalty_tier.upper_bound);
  // $('[data-loyalty-progress-bar]').attr('max', upper_bound);
  // $('[data-loyalty-progress-bar]').val(upper_bound - (upper_bound - loyalty_customer.loyalty.points_approved));
  // console.log(lower_bound, upper_bound, loyalty_customer.loyalty.points_approved, (1 - ((upper_bound - loyalty_customer.loyalty.points_approved) / upper_bound)));
  progressMeter(((available_dollars - lower_bound) / upper_bound).toFixed(2));
  */

  progressWidget(tier_name.toLowerCase(), 1);

  // Number animation
  window.setTimeout(() => {
    // $('.loyalty-counter').each((i, item) => {
    //   const $item = $(item);
    //   console.log($item.text())
    //   $({ Counter: 0 }).animate({ Counter: $item.text() }, {
    //     duration: 1000,
    //     easing: 'swing',
    //     step: function () {
    //       $item.text(Math.ceil(this.Counter));
    //     }
    //   });
    // });

    $('.loyalty-counter').each(() => {
      $(this).prop('Counter',0).animate({
        Counter: $(this).text()
      }, {
        duration: 4000,
        easing: 'swing',
        step: (now) => {
          $(this).text(Math.ceil(now));
        },
      });
    });
  }, 1);
};